<ng-template #defaultTamplate>Please provide your template</ng-template>
<div class="cs-value-panel" draggable [dragData]="{item:ngModel}" [dragOverClass]="'drag-over'">
	<ng-template [ngTemplateOutlet]="template|| inlineTemplate ||defaultTamplate"
				 [ngTemplateOutletContext]="{item: ngModel}"></ng-template>
	<div class="action-buttons">
		<button class="btn btn-primary" *ngFor="let action of actions"
				(click)="actionClicked(action)">{{action.name}}</button>
	</div>
</div>
